/**
 * A place for SideFilterAndContent setup
 */
namespace appn.sideFilterAndContent {

    class InitArgs {
        optionalContentToTheRight: boolean = false;
        showButtonText: string = emptyString;
        showButtonIcon: string = emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs) {
        _initArgs = args;

        addEvents();

        // Check local storage for flag
        if (localStorage.getItem('sidefilter-toggle-collapsed')) {
            hideSideFilter();
            return;
        }

        $('body').removeClass('sideFilter-hidden').addClass('sideFilter-shown');
    }

    export function appendShowButton(hostElementSelector: JQuery<HTMLElement>, classes?: string): void {
        if (!hostElementSelector)
            return;

        hostElementSelector.append(getShowBtn(classes));
        init(_initArgs);
    }

    export function prependShowButton(hostElementSelector: JQuery<HTMLElement>, classes?: string): void {
        if (!hostElementSelector)
            return;

        hostElementSelector.prepend(getShowBtn(classes));
        init(_initArgs);
    }

    function saveFilterState(): void {
        if (localStorage.getItem('sidefilter-toggle-collapsed'))
            localStorage.setItem('sidefilter-toggle-collapsed', emptyString);
        else
            localStorage.setItem('sidefilter-toggle-collapsed', '1');
    }

    function hideSideFilter(): void {
        $('#elastic-right').hide();

        if (_initArgs.optionalContentToTheRight === true)
            $('#elastic-fill').removeClass('col-md-7').addClass('col-md-9');
        else
            $('#elastic-fill').removeClass('col-md-10').addClass('col-md-12');

        $('#showSideFilter').show();
         
        // Delay this call so the UI doesnt get stuck when there is lots of data
        appn.dataTable.redrawOnResize(100);
        $('body').removeClass('sideFilter-shown').addClass('sideFilter-hidden');

        appn.pubSub.publish(appn.pubSub.WINDOW_RESIZED);

        if ($('body').hasClass('appn-view-tasks-calendar'))
            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 300);
    }

    function showSideFilter() {
        if (_initArgs.optionalContentToTheRight === true)
            $('#elastic-fill').removeClass('col-md-9').addClass('col-md-7');
        else
            $('#elastic-fill').removeClass('col-md-12').addClass('col-md-10');

        $('#elastic-right').show();
        $('#showSideFilter').hide();

        // Delay this call so the UI doesnt get stuck when there is lots of data
        appn.dataTable.redrawOnResize(100);
        $('body').removeClass('sideFilter-hidden').addClass('sideFilter-shown');

        appn.pubSub.publish(appn.pubSub.WINDOW_RESIZED);

        if ($('body').hasClass('appn-view-tasks-calendar'))
            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 300);
    }

    function getShowBtn(classes?: string) {
        const filterBtnClass = `class="btn btn-tool ${(classes ? classes : emptyString)}"`;
        const filterBtnIcon = '<i class="fa fa-filter"></i>';
        const btnHtml = `<button id="showSideFilter" title="Show more Filters" style="display: none;" ${filterBtnClass} type="button">${filterBtnIcon}</a>`;
        return btnHtml;
    }

    function addEvents(): void {
        $('.hideSideFilter').off().on('click', function(event) {
            event.preventDefault();
            hideSideFilter();
            saveFilterState();
        });

        $('#showSideFilter').off().on('click', function(event) {
            event.preventDefault();
            showSideFilter();
            saveFilterState();
        });
    }
}
